enum OTP_FORM_BASIC_INFO {
  otpForm = 'otpForm',
  otpInput = 'otpInput',
  otpModalLoading = 'otpModalLoading',
}

export { OTP_FORM_BASIC_INFO };
